import { useMutation } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";
import axios from "axios";



const verifySso = async({sessionId}) => {

    const response = await axios.post(
        `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=ssoStatus&sessionId=${sessionId}`
    )

    return response.data;
}


const useVerifySso = (options = {}) => {
  return useMutation({
    mutationFn: verifySso,
    ...options,
  });
};

export default useVerifySso;